import { render, staticRenderFns } from "./EstimateClipboardTasks.vue?vue&type=template&id=297a5a76&"
import script from "./EstimateClipboardTasks.vue?vue&type=script&lang=js&"
export * from "./EstimateClipboardTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports